import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const MenuButtonIcon = styled.button`
  z-index: 102;

  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${calculateResponsiveSize(8)};
  width: ${calculateResponsiveSize(36)};

  position: fixed;
  right: ${calculateResponsiveSize(42)};
  top: ${calculateResponsiveSize(35)};

  span {
    display: flex;
    width: ${calculateResponsiveSize(36)};
    height: 1px;
    background: #fff;
    transition: 0.5s;
    position: relative;
  }

  .home-wrapper.open-menu & {
    span {
      transform: rotate(45deg);
      top: -${calculateResponsiveSize(5)};
      width: ${calculateResponsiveSize(40)};
      background: var(--blue);
    }
    span:first-child {
      transform: rotate(-45deg);
      top: ${calculateResponsiveSize(5)};
      width: ${calculateResponsiveSize(40)};
    }
    span:nth-child(2) {
      display: none;
    }
  }

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(24)};
    gap: ${calculateMobileResponsiveSize(7)};
    right: ${calculateMobileResponsiveSize(32)};
    top: ${calculateMobileResponsiveSize(25)};

    span {
      width: ${calculateMobileResponsiveSize(24)};
      height: 1px;
    }
    span:nth-child(2) {
      display: none;
    }

    .home-wrapper.open-menu & {
      span {
        background: #fff;

        top: -${calculateMobileResponsiveSize(4.5)};
        width: ${calculateMobileResponsiveSize(28)};
      }
      span:first-child {
        top: ${calculateMobileResponsiveSize(4.5)};
        width: ${calculateMobileResponsiveSize(28)};
      }
    }
  }
`
